"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decrement = exports.increment = exports.isLower = exports.isGreater = void 0;

var _stringToNumber = require("./string-to-number");

const isGreater = (amount, max) => (0, _stringToNumber.stringToNumber)(amount) > (0, _stringToNumber.stringToNumber)(max.amount);

exports.isGreater = isGreater;

const isLower = (amount, min) => (0, _stringToNumber.stringToNumber)(amount) < (0, _stringToNumber.stringToNumber)(min.amount);

exports.isLower = isLower;

const getRangeValue = (value, min, max) => {
  if (isLower(value, min)) return min.amount;
  if (isGreater(value, max)) return max.amount;
  return value;
};

const increment = (amount, amountIncrement, min, max) => {
  const value = (0, _stringToNumber.stringToNumber)(amount) + amountIncrement;
  return getRangeValue(value, min, max);
};

exports.increment = increment;

const decrement = (amount, amountIncrement, min, max) => {
  const value = (0, _stringToNumber.stringToNumber)(amount) - amountIncrement;
  return getRangeValue(value, min, max);
};

exports.decrement = decrement;